function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M8.0614 70.4693V22.917L22.1715 16.2534H53.0104V70.4693",
  fill: "#F2FFED"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M54.5189 70.4694H51.502V17.762H22.5097L9.56983 23.8729V70.4694H6.55298V22.9172C6.55299 22.6313 6.63425 22.3513 6.78727 22.1098C6.9403 21.8683 7.1588 21.6753 7.41731 21.5533L21.5274 14.8896C21.7289 14.7945 21.9488 14.7452 22.1715 14.7451H53.0104C53.4105 14.7451 53.7942 14.904 54.077 15.1869C54.3599 15.4698 54.5189 15.8535 54.5189 16.2535V70.4694Z",
  fill: "#40BA5B"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M8.0614 34.7295H53.0104L67.3936 41.261V71.6814H8.0614V34.7295Z",
  fill: "#F2FFED"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M67.3936 73.19H8.06141C7.66135 73.19 7.27767 73.0311 6.99479 72.7482C6.7119 72.4653 6.55298 72.0816 6.55298 71.6816V34.7296C6.55298 34.3296 6.7119 33.9459 6.99479 33.663C7.27767 33.3801 7.66135 33.2212 8.06141 33.2212H53.0104C53.2255 33.2212 53.4382 33.267 53.634 33.356L68.0172 39.8875C68.281 40.0074 68.5047 40.2006 68.6616 40.4442C68.8185 40.6878 68.902 40.9714 68.902 41.2611V71.6816C68.902 72.0816 68.7431 72.4653 68.4602 72.7482C68.1773 73.0311 67.7936 73.19 67.3936 73.19ZM9.56983 70.1731H65.8852V42.2328L52.684 36.238H9.56983V70.1731Z",
  fill: "#40BA5B"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M22.1715 71.6816V1.71533H53.0104V71.6816",
  fill: "#F2FFED"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M54.5188 71.6813H51.502V3.2234H23.6799V71.6813H20.6631V1.71497C20.6631 1.31491 20.822 0.931236 21.1049 0.648351C21.3878 0.365466 21.7715 0.206543 22.1715 0.206543H53.0104C53.4105 0.206543 53.7941 0.365466 54.077 0.648351C54.3599 0.931236 54.5188 1.31491 54.5188 1.71497V71.6813Z",
  fill: "#40BA5B"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M0 70.4746H75.7767V73.4915H0V70.4746Z",
  fill: "#40BA5B"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M35.9893 1.71533H39.0061V71.6816H35.9893V1.71533Z",
  fill: "#40BA5B"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M9.35107 51.3944H67.3936V54.4113H9.35107V51.3944ZM22.1715 33.2212H53.0104V36.238H22.1715V33.2212Z",
  fill: "#40BA5B"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M37.4978 34.7295H53.0105V52.9027H37.4978V34.7295Z",
  fill: "#FFE43F"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M53.0104 54.4113H37.4977C37.0977 54.4113 36.714 54.2524 36.4311 53.9695C36.1482 53.6866 35.9893 53.303 35.9893 52.9029V34.7297C35.9893 34.3296 36.1482 33.9459 36.4311 33.663C36.714 33.3802 37.0977 33.2212 37.4977 33.2212H53.0104C53.4105 33.2212 53.7941 33.3802 54.077 33.663C54.3599 33.9459 54.5188 34.3296 54.5188 34.7297V52.9029C54.5188 53.303 54.3599 53.6866 54.077 53.9695C53.7941 54.2524 53.4105 54.4113 53.0104 54.4113ZM39.0062 51.3945H51.502V36.2381H39.0062V51.3945ZM22.1715 14.7451H53.0104V17.762H22.1715V14.7451Z",
  fill: "#40BA5B"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M22.1715 1.71533H37.4977V16.2536H22.1715V1.71533Z",
  fill: "#FFE43F"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M37.4977 17.7616H22.1715C21.7715 17.7616 21.3878 17.6027 21.1049 17.3198C20.822 17.0369 20.6631 16.6533 20.6631 16.2532V1.71497C20.6631 1.31491 20.822 0.931236 21.1049 0.648351C21.3878 0.365466 21.7715 0.206543 22.1715 0.206543H37.4977C37.8978 0.206543 38.2815 0.365466 38.5644 0.648351C38.8472 0.931236 39.0062 1.31491 39.0062 1.71497V16.2532C39.0062 16.6533 38.8472 17.0369 38.5644 17.3198C38.2815 17.6027 37.8978 17.7616 37.4977 17.7616ZM23.6799 14.7448H35.9893V3.2234H23.6799V14.7448Z",
  fill: "#40BA5B"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.15,
  d: "M64.7385 70.6377H8.66479V67.6209H63.23V40.083H66.2469V69.1293C66.2469 69.5293 66.088 69.913 65.8051 70.1959C65.5222 70.4788 65.1385 70.6377 64.7385 70.6377Z",
  fill: "#40BA5B"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.15,
  d: "M48.8999 1.71533H51.9168V67.4704H48.8999V1.71533Z",
  fill: "#40BA5B"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.15,
  d: "M32.9106 1.71533H35.9275V67.4704H32.9106V1.71533Z",
  fill: "#40BA5B"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.15,
  d: "M17.7299 17.6387H20.7467V67.621H17.7299V17.6387Z",
  fill: "#40BA5B"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M23.6471 3.25146H26.6639V14.7155H23.6471V3.25146Z",
  fill: "white"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M39.4473 37.5435H42.4641V49.0075H39.4473V37.5435Z",
  fill: "white"
});

function SvgBusiness(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 74,
    viewBox: "0 0 76 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusiness);
export default __webpack_public_path__ + "static/media/business.6a80bbd7.svg";
export { ForwardRef as ReactComponent };